module.exports = __webpack_public_path__ + "static/media/heatmap.5e019d45.png";